// extracted by mini-css-extract-plugin
module.exports = {"scrollFix":"frameStyling-module--scroll-fix--2byf9","frameStyle":"frameStyling-module--frame-style--OSZFs","alignForm":"frameStyling-module--align-form--168Q3"};